<span>
    <ng-content></ng-content>
</span>

<i
    *ngIf="icon"
    [class]="icon"
></i>
